import React, {Component} from 'react'
import {connect} from 'react-redux'
import Dashboard from "./Dashboard";

class HomePage extends Component {

	// constructor(props) {
	// 	super(props)
	// }

	componentDidMount() {
	}

	componentWillUnmount() {
	}

	render() {
		return <Dashboard match={this.props.match} history={this.props.history}/>
	}
}

const mapStateToProps = (state, ownProps) => {
	return {}
};

export default connect(mapStateToProps, {})(HomePage)
